module.exports = __webpack_public_path__ + "img/查看外文期刊详情.b24a7e95.png";